module.exports = __webpack_public_path__ + "img/banner1.e396b59b.png";